import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServerService } from 'src/app/services/server.service';
import { UserListModalComponent } from '../user-list-modal/user-list-modal.component';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-by-client',
  templateUrl: './project-by-client.component.html',
  styleUrls: ['./project-by-client.component.scss']
})
export class ProjectByClientComponent implements OnInit {

  authToken = localStorage.getItem('token');
  users: any;

  url: any;

  projectData:any;
  projectByClient:any;

  pageIndex: number = 0;
  pageSize: number = 100;

  showComponentLoader: boolean = false;

  ELEMENT_DATA: any[] = [
    {id: 1, name: 'Hydrogen'},
    {id: 2, name: 'Helium'},
    {id: 3, name: 'Lithium'},
    {id: 4, name: 'Beryllium'},
    {id: 5, name: 'Boron'},
    {id: 6, name: 'Carbon'},
    {id: 7, name: 'Nitrogen'},
    {id: 8, name: 'Oxygen'},
    {id: 9, name: 'Fluorine'},
    {id: 10, name: 'Neon'},
  ];

  displayedColumns: string[] = ['sr', 'id', 'name'];
  dataSource = this.ELEMENT_DATA;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialogRef: MatDialogRef<UserListModalComponent>,
    private serverservice: ServerService,
    private clipBoardService: ClipBoardService,    
    private router: Router,
  ) {    
    this.projectData = data
    //console.log(this.projectData)
  }

  ngOnInit() {
    this.allClientProjects(this.projectData.client_id);
  }


  allClientProjects(clientId: any) {

    let body = {
      client_id: clientId,
      lead_count_n_latest: true
    }

    this.url = "projects_with_filter/?per_page=" + this.pageSize + "&page=" + this.pageIndex;

    this.serverservice.projectsListByFilter(this.url, body, this.authToken).subscribe(
      data => {
        this.projectByClient = data.projects;
        // console.log(this.projectByClient)
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  close() {
    this.dialogRef.close();
  }


  viewLeadsByProjects(project) {
    if (!project.disable) {
      // localStorage.setItem("projectInfo", JSON.stringify(project))
      sessionStorage.setItem("projectInfo", JSON.stringify(project))
      // this.router.navigate(["/page/project/leads"])
      this.router.navigate([]).then(result => { window.open('/page/project/leads/' + project.id, '_blank'); });
    }
  }


}
